import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextBlock"><Path d="M12 4.5V6.5H21V4.5H12Z" fill="currentColor"/><Path d="M12 7.5V9.5H18V7.5H12Z" fill="currentColor"/><Path d="M12 14.5V16.5H21V14.5H12Z" fill="currentColor"/><Path d="M12 17.5V19.5H18V17.5H12Z" fill="currentColor"/><Path d="M3 4V10H9V4H3Z" fill="currentColor"/><Path d="M3 14V20H9V14H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextBlock;
